import { put, select, fork } from 'redux-saga/effects'
import { identity, isNull, isUndefined, isArray } from 'lodash'
import qs from 'query-string'
import { takeLatestAndCancel } from './take'
import { authApiCall } from './helpers'
import { isExternalItemId } from '../utils'

// Vary Fix for bad API
const mapItems = items =>
  items.map(item => {
    // Fix posseduto da
    const possedutoDa = isArray(item.posseduto_da)
      ? item.posseduto_da
      : isUndefined(item.posseduto_da) || isNull(item.posseduto_da)
          ? []
          : [item.posseduto_da]

    // Cast to int when needed
    const id = isExternalItemId(item.id)
      ? item.id
      : isNaN(item.id) ? item.id : +item.id

    return {
      ...item,
      id,
      posseduto_da: possedutoDa,
    }
  })

// Saga for a paginated list of *items*
const makeItemsSaga = (
  prefixActionType,
  apiFn,
  selectState,
  transform = identity,
  pageSize = 50
) => {
  function* handleGetItems({ payload: { params, reset, cacheKey } }) {
    const prevCacheKey = yield select(state => selectState(state).cache.key)
    if (cacheKey && prevCacheKey) {
      if (prevCacheKey === cacheKey) {
        // Yeah ! Like a little redis!
        yield put({
          type: `${prefixActionType}_HIT_CACHE`,
          payload: {
            cacheKey,
          },
        })
        // Prevent the http call
        return
      } else {
        // Clear cache
        yield put({
          type: `${prefixActionType}_CLEAR_CACHE`,
        })
      }
    }

    yield put({ type: `${prefixActionType}_LOADING` })
    try {
      const offset = reset
        ? 0
        : yield select(state => selectState(state).pagination.nextOffset)
      const { items, next, total_items } = yield authApiCall(apiFn, {
        ...params,
        limit: pageSize,
        offset,
      })
      const nextOffset = next ? +qs.parse(qs.extract(next)).offset : null
      yield put({
        type: `${prefixActionType}_SUCCESS`,
        payload: {
          total: +total_items,
          items: transform(mapItems(items)),
          nextOffset,
          reset,
        },
      })
    } catch (error) {
      yield put({ type: `${prefixActionType}_FAILURE`, error })
    }
  }

  return function* watchItems() {
    yield fork(
      takeLatestAndCancel,
      prefixActionType,
      `${prefixActionType}_UNLOAD`,
      handleGetItems
    )
  }
}

export default makeItemsSaga



// WEBPACK FOOTER //
// ./src/saga/makeItems.js